import React from "react";
import BrandLogo from "../BrandLogo";
import styles from "./Signup/SignUp.module.css";

/** Shared brand + form layout for login, signup, and email-sent. */
const AuthShell = ({ children, subtitle }) => (
  <div className={styles.container}>
    <div className={styles.shell}>
      <aside className={styles.brandPanel} aria-label="Dblog">
        <div className={styles.brandPanelInner}>
          <div className={styles.brandLockupWrap}>
            <BrandLogo home />
          </div>
          {subtitle ? <p className={styles.brandSubtitle}>{subtitle}</p> : null}
        </div>
      </aside>
      <main className={styles.formStage}>{children}</main>
    </div>
  </div>
);

export default AuthShell;
